import { render } from "./GoogleRedirect.vue?vue&type=template&id=3ba5f84a&ts=true"
import script from "./GoogleRedirect.vue?vue&type=script&lang=ts"
export * from "./GoogleRedirect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__